export const costs = [
  'Information scattered across agency bulletins, news, papers and videos',
  'No clear way to translate an ENSO forecast into site-level actions',
  'Drainage, water, power and heat risks managed separately, or not at all',
  'Preparing late, when the season has already started',
];
